/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Recreate_Disabled_PaidInputs */

const vi_order_recreate_disabled_paid = /** @type {(inputs: Order_Recreate_Disabled_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã phát sinh thanh toán — không tạo lại được`)
};

/**

* @param {Order_Recreate_Disabled_PaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_recreate_disabled_paid = /** @type {((inputs?: Order_Recreate_Disabled_PaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Recreate_Disabled_PaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_recreate_disabled_paid(inputs)
});